module.exports = __webpack_public_path__ + "img/ES.c2f80d15.svg";